import { render } from "./NewDynamicForm.vue?vue&type=template&id=1f420a84&scoped=true"
import script from "./NewDynamicForm.vue?vue&type=script&lang=js"
export * from "./NewDynamicForm.vue?vue&type=script&lang=js"

import "./NewDynamicForm.vue?vue&type=style&index=0&id=1f420a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f420a84"]])

export default __exports__